import Vue from 'vue'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { initSentry } from '../../sentry/main'
import App from './index.vue'
import MyMixins from './mixins'
import store from './store'

Vue.config.productionTip = false
Vue.mixin(MyMixins)
initSentry(Vue)
/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  render: h => h(App)
})
